var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"relative w-full overflow-x-hidden overflow-y-hidden"},[_c('Page-nav',{attrs:{"menu-opened":_vm.mobileMenuOpen},on:{"toggle-menu":_vm.toggleMenu}}),_c('Page-header'),_c('About-me'),_c('Experience'),_c('Skills'),_c('Projects'),_c('Page-footer')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }